import { useEffect } from 'react';
import { createCookieBotScript, getCookie } from '../utils/cookies';

export const useCookieBotScript = (): void => {
  const locale = getCookie('locale_player');

  useEffect(() => {
    if (locale) createCookieBotScript(locale);
  }, [locale]);
};
